var map = {
	"./hero-careers.png": 9062,
	"./hero-dark.png": 4467,
	"./hero.png": 928,
	"./illustration.png": 8970,
	"./image-notfound.png": 9177,
	"./logo_borneo.png": 5931,
	"./logomgr.png": 2911,
	"./no-careers.png": 1691,
	"./radius.svg": 7776,
	"./texture.png": 1023,
	"./title_about.png": 7410,
	"./title_mission.png": 7527,
	"./title_partners.png": 2388,
	"./title_product.png": 5192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;